import ReactGA from "react-ga4";

// Single lead-conversion signal shared by BOTH the contact page and the chat
// assistant, so every submission rolls up into one GA4 conversion that can still
// be segmented.
//
// GA only auto-sends the initial pageview (see App.js) and does not track SPA
// route changes, so a lead completion has to be reported explicitly:
//   1. a pageview to the shared /thank-you URL — the single conversion URL, and
//   2. a GA4 `generate_lead` event tagged with `source` and `lead_type`.
//
// The contact page reaches /thank-you by real navigation (the page fires this on
// mount); the chat widget must not navigate away, so it calls this directly as a
// "virtual pageview". Both therefore land on the same /thank-you conversion.
//
// Mark `generate_lead` (or the /thank-you pageview) as a conversion in GA4 Admin
// — that part is dashboard-side and cannot be done from code.
//
// @param {Object} opts
// @param {"contact_page"|"chat"} opts.source     Where the lead came from.
// @param {"inquiry"|"partnership"} opts.leadType Kind of lead.
export const trackLead = ({ source, leadType }) => {
  try {
    ReactGA.send({
      hitType: "pageview",
      page: "/thank-you",
      title: "Thank You"
    });
    ReactGA.event("generate_lead", { source, lead_type: leadType });
  } catch (e) {
    /* analytics is best-effort */
  }
};
